/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PosBrokerDTO } from './PosBrokerDTO';

export type PosCertificateResponseDTO = {
    broker?: PosBrokerDTO;
    certificate?: string;
    certificateId?: string;
    notAfter?: string;
    status?: PosCertificateResponseDTO.status;
    terminalId?: string;
};

export namespace PosCertificateResponseDTO {

    export enum status {
        PENDING = 'PENDING',
        ISSUED = 'ISSUED',
        REVOKED = 'REVOKED',
    }


}
